// ⬡B:ccwa_core.aura:CODE:render_real_aba_consciousness_mark:20260613⬡
// AURA — the living ABA presence in every CCWA surface. The center IS the real
// ABA mark now, the ABAConsciousness energy blob, your documented primary logo,
// purple energy inside energy, never a sphere or a particle, color-shifting by
// state. It is imported from the one shared source in gmgu-core, never copied, so
// the same mark renders everywhere it is used.
//
// The component interface is unchanged so callers (CCWAMood, CcwaRoute) need no
// edit: onTap drives push-to-talk, state drives the mark's color language, size
// sets the canvas. AURA carries a muted state the brand mark has no palette for,
// so a muted mic folds to the calm idle energy rather than an undefined state.

import React from 'react';
import { ABAConsciousness } from '@aba/gmgu-core';

const STATE_MAP = {
  idle: 'idle',
  listening: 'listening',
  thinking: 'thinking',
  speaking: 'speaking',
  muted: 'idle',
};

// Worded state so color is never the only signal (Front-End Model item 12).
const STATE_WORDS = { idle: 'Idle', listening: 'Listening', thinking: 'Thinking', speaking: 'Speaking', muted: 'Muted' };
const STATE_COLOR = { idle: 'rgba(255,255,255,0.55)', listening: '#7ed4a1', thinking: '#f5d99a', speaking: '#e2b14c', muted: 'rgba(255,255,255,0.40)' };

export function AURA({
  state = 'idle',
  amplitude = 0,
  size = 220,
  onTap = null,
  label = 'Tap to talk',
  className = '',
  showState = true,
}) {
  const markState = STATE_MAP[state] || 'idle';
  const word = STATE_WORDS[state] || 'Idle';
  const active = state && state !== 'idle' && state !== 'muted';
  const hint = onTap ? (active ? 'Tap to stop' : 'Tap to talk') : '';
  return (
    <div
      className={`aba-aura-wrap ${className}`}
      style={{ display: 'inline-flex', flexDirection: 'column', alignItems: 'center', gap: 12, userSelect: 'none' }}
    >
      <div
        className="aba-aura"
        role="button"
        aria-label={label}
        tabIndex={0}
        onClick={onTap || undefined}
        onKeyDown={(e) => { if (onTap && (e.key === 'Enter' || e.key === ' ')) onTap(e); }}
        style={{
          width: size,
          height: size,
          cursor: onTap ? 'pointer' : 'default',
          display: 'inline-flex',
          alignItems: 'center',
          justifyContent: 'center',
          WebkitTapHighlightColor: 'transparent',
        }}
      >
        <ABAConsciousness size={size} state={markState} />
      </div>
      {showState && (
        <div className="aba-aura-caption" style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 2, lineHeight: 1.3, textAlign: 'center' }}>
          <span className="aba-aura-state" style={{ fontSize: 13, fontWeight: 600, letterSpacing: '0.6px', color: STATE_COLOR[state] || STATE_COLOR.idle, transition: 'color 0.25s' }}>{word}</span>
          {hint && <span className="aba-aura-hint" style={{ fontSize: 11, color: 'rgba(255,255,255,0.45)' }}>{hint}</span>}
        </div>
      )}
    </div>
  );
}

export default AURA;
